import { APEX } from 'alphapoint';
var apex = {
  connection: {},
  gateway: ''
};
export var setGateway = function setGateway(gateway) {
  apex.gateway = gateway;
  apex.connection = {};
};
export var initApex = function initApex(onopen, onclose) {
  var gateway = apex.gateway;
  apex.connection = new APEX(gateway, {
    onopen: onopen,
    onclose: onclose
  });
  apex.connection.standardCallback = function () {};
};
export var getApex = function getApex() {
  var onopen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var onclose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  if (!apex.connection.ws) {
    var server = void 0;
    var cookie = localStorage.getItem('tradingServer');
    if (apex.gateway) server = apex.gateway;
    if (cookie) server = cookie;
    if (!server) {
      // context.t("Gateway not selected")
      throw new Error('Gateway not selected');
    }
    setGateway(server);
    initApex(onopen, onclose);
  }
  return apex;
};
export default apex;